const months = {
  1: "January",
  2: "Febuary",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

const monthQuarters = {
  1: "1",
  2: "1",
  3: "1",
  4: "2",
  5: "2",
  6: "2",
  7: "3",
  8: "3",
  9: "3",
  10: "4",
  11: "4",
  12: "4",
};

export const defaultOptions = (primaryLabel) => {
  let primaryType = `${primaryLabel}s`;
  return {
    searchTerm: window?.sessionStorage?.getItem(`${primaryType}_searchTerm`) || "",
    sortBy: "refNumber", // Options: refNumber, jobReceived, created
    customerFilter: "all",
    jobStatusFilter: window?.sessionStorage?.getItem(`${primaryType}_jStatus`) || "all",
    statusFilter: window?.sessionStorage?.getItem(`${primaryType}_statusFilter`) || "all",
    quarterFilter: "all",
    order: true,
    primaryType: primaryType,
    viewWindow: 3,
  };
};

const determineOrder = (first, second, order) => {
  let a = undefined;
  let b = undefined;

  if (order) {
    a = first;
    b = second;
  } else {
    a = second;
    b = first;
  }
  return [a, b];
};

const byJobReceived = (first, second, blank, order) => {
  let [a, b] = determineOrder(first, second, order);

  let c = new Date(b.jobReceived).getTime() - new Date(a.jobReceived).getTime();
  return c;
};

const byRefNumber = (first, second, blank, order) => {
  let [a, b] = determineOrder(first, second, order);

  let c = Number(b.refNumber) - Number(a.refNumber);
  return c;
};

// const byJobDate = (first, second, blank, order) => {
//   let [a, b] = determineOrder(first, second, order);

//   let c = new Date(b.jobDate).getTime() - new Date(a.jobDate).getTime();
//   return c;
// };

const byCreated = (first, second, blank, order) => {
  let [a, b] = determineOrder(first, second, order);

  //console.log("a created", new Date(a.created).getTime());
  //console.log("b created", new Date(b.created).getTime());

  // console.log(
  //   "is greater?",
  //   new Date(b.created).getTime() - new Date(a.created).getTime()
  // );

  let c = new Date(b.created).getTime() - new Date(a.created).getTime();

  return c;
};

export const section = (timesheets = []) => {
  //Take in primary data as an array and split it up into an array of sections,
  //with each section containing a title: (which is the primary datas month and year),
  //and the data: which contains an array of the primary data for that month and year.
  let sections = {};
  let formattedSections = [];

  timesheets.forEach((ts) => {
    let date = new Date(ts.jobReceived);
    let year = date.getFullYear();
    let numMonth = date.getMonth() + 1;
    let month = numMonth ? months[numMonth] : null;

    let key = month + " - " + year;

    if (!ts.jobReceived) {
      key = " -- / --";
    }

    if (key) {
      if (sections[key]) {
        sections[key].push({ ...ts });
      } else {
        sections[key] = [];
        sections[key].push({ ...ts });
      }
    }
  });

  for (let sec in sections) {
    formattedSections.push({
      title: sec,
      data: [...sections[sec]],
    });
  }

  formattedSections = formattedSections.sort((a, b) => {
    return byJobReceived(a.data[0], b.data[0], null, true);
  });

  return formattedSections;
};

export function filterPrimaries(
  primaries = [],
  {
    customerFilter = "all",
    statusFilter = "all",
    quarterFilter = "all",
    jobStatusFilter = "all",
    searchTerm = "",
  }
) {
  //Filter functions to apply to passed in data
  let filterFuncsToApply = [
    function byJobStatus(primaries) {
      if (jobStatusFilter === "all") {
        return primaries;
      } else if (jobStatusFilter === "no-status") {
        return primaries.filter((j) => {
          if (!j?.status || j?.status === "" || j?.status === undefined || j?.status === "no-status") {
            return true;
          }
        });
      } else {
        return primaries.filter((j) => j.status === jobStatusFilter);
      }
    },
    function bySearchTerm(primaries) {
      if (!searchTerm) {
        return primaries;
      }

      return primaries.filter((primary) => {
        let {
          refNumber = "",
          accessId = "",
          authorisedBy = "",
          name = "",
          worksOrderNumber = "",
          email = "",
          number = "",
          address = "",
          postcode = "",
        } = primary;

        let ref = String(refNumber).toLowerCase().replaceAll(" ", "");
        let woNumber = String(worksOrderNumber).toLowerCase().replaceAll(" ", "");
        let accessid = String(accessId.toLowerCase().replaceAll(" ", ""));
        let addressLine = String(address.trim().toLowerCase().replaceAll(" ", ""));

        let customerEmail = String(email.trim().toLowerCase().replaceAll(" ", ""));
        let postalCode = String(postcode.trim().toLowerCase().replaceAll(" ", ""));
        let phoneNumber = String(number.replaceAll(" ", ""));
        let filter = String(searchTerm.trim().toLowerCase().replaceAll(" ", ""));
        let customerName = String(name.trim().toLowerCase().replaceAll(" ", ""));
        let privateCustomerName = String(authorisedBy.trim().toLowerCase().replaceAll(" ", ""));

        return (
          ref.includes(filter) ||
          woNumber.includes(filter) ||
          phoneNumber.includes(filter) ||
          addressLine.includes(filter) ||
          postalCode.includes(filter) ||
          accessid.toLowerCase().includes(filter) ||
          customerEmail.includes(filter) ||
          customerName.includes(filter) ||
          privateCustomerName.includes(filter)
        );
      });
    },
    function byQuarter(primaries) {
      if (quarterFilter === "all") {
        return primaries;
      }
      return primaries.filter(({ jobReceived = "" }) => {
        if (!jobReceived) return false;

        let primaryDateReceived = new Date(jobReceived);
        let month = primaryDateReceived.getMonth() + 1;

        let monthQuarter = monthQuarters[month];

        return quarterFilter === monthQuarter;
      });

      //return data.map((x) => x * 2);
    },
    function byCustomer(primaries) {
      // console.log("in customerFilter: :", customerFilter);

      if (customerFilter === "all") {
        return primaries;
      }
      return primaries.filter(({ customerUid = "" }) => {
        if (!customerUid) return false;
        return customerUid === customerFilter;
      });
    },
    function byStatus(primaries) {
      if (statusFilter === "all") {
        return primaries;
      } else if (statusFilter === true || statusFilter === false) {
        // Need to reconvert from string here as it sometimes comes from
        // localStorage.
        statusFilter = Boolean(statusFilter);
        return primaries.filter(({ paid = false }) => {
          return paid === statusFilter;
        });
      } else if (statusFilter === "sub") {
        return primaries.filter(({ subcontracted = false }) => {
          return subcontracted === true;
        });
      }
    },
  ];

  //Apply each filter function to the data passed in.
  let filteredData = filterFuncsToApply.reduce((data, func) => {
    let newData = func(data);
    return newData;
  }, primaries);

  return filteredData;
}

//Sorting Functions//////////////////////////////////////////////

function sorter(primaries = [], { sortBy, order }) {
  let sortOptions = {
    jobReceived: byJobReceived,
    created: byCreated,
    refNumber: byRefNumber,
  };

  let sortedPrimaries = primaries.sort((a, b) => {
    return sortOptions[sortBy](a, b, null, order);
  });

  return sortedPrimaries;
}

export function sortPrimaries(sectionedData, options) {
  let sortedSections = sectionedData.map(({ title, data }) => {
    let sortedData = sorter(data, options);

    return {
      title,
      data: sortedData,
    };
  });

  // console.log("sortedSections", sortedSections);
  return sortedSections;
}

// export function sortJobDescriptions(jobDescriptions) {
//   console.log("jobDescriptions coming in", jobDescriptions);
//   let sortedJobs = jobDescriptions.sort(byJobDate);
//   console.log("sorted jobDescriptions", sortedJobs);
// }

//End of Sorting Functions////////////////////////////////////////////
